// DE locale — single source of truth pro UI strings.
// v0.1 hardcoded jeden jazyk; v0.2 přidáme přepínač + EN soubor.

export const t = {
  app: {
    name: "Partner-Portal",
    company: "Warmteo GmbH",
  },
  nav: {
    dashboard: "Dashboard",
    thisWeek: "Diese Woche",
    nextWeek: "Nächste Woche",
    orders: "Alle Aufträge",
    invoices: "Rechnungen",
    balance: "Offene Posten",
    map: "Karte",
    shop: "Werkstatt-Shop",
    profile: "Profil",
    live: "Live",
    soon: "Bald",
    abrechnungUeber: "Abrechnung über",
  },
  login: {
    eyebrow: "Partner-Portal",
    titleEmail: "Willkommen zurück.",
    titleCode: "Code eingeben",
    intro: "Geben Sie Ihre Geschäfts-E-Mail an. Wir senden Ihnen einen einmaligen Code.",
    introCode: (email: string) => `Wir haben einen 8-stelligen Code an ${email} gesendet.`,
    emailLabel: "E-Mail",
    emailPlaceholder: "ihre@firma.de",
    requestCode: "Code anfordern",
    haveCode: "Ich habe bereits einen Code →",
    changeEmail: "← E-Mail ändern",
    resendCode: "Code erneut senden",
    footerNote: "Ihr Account wird vom Backoffice freigeschaltet.",
    footer: ["© 2026 Warmteo GmbH", "Datenschutz", "Impressum"],
    invalidCode: "Code ungültig oder abgelaufen.",
  },
  dashboard: {
    greetingMorning: (name: string) => `Hallo, ${name}.`,
    weekSubtitle: (count: number, complaints: number) =>
      `Diese Woche stehen ${count} Aufträge an.${
        complaints > 0
          ? ` ${complaints === 1 ? "Eine Reklamation wartet" : `${complaints} Reklamationen warten`} auf Rückmeldung.`
          : ""
      }`,
    actionsMap: "Karte öffnen",
    actionsNew: "Neue Anfrage",
    kpi: {
      thisWeek: "Diese Woche",
      thisWeekSub: "Aufträge",
      weOwe: "Wir schulden Ihnen",
      weOweSubOpen: (count: number) => `${count} offene Rechnungen`,
      weOweSubAge: (days: number) => `ältester ${days} T.`,
      complaints: "Reklamationen",
      complaintsSubOpen: "offen",
      revenue: "Umsatz Mai (lfd.)",
      revenueSubDone: (count: number) => `${count} abgeschlossene Aufträge`,
    },
    sectionThisWeek: "Diese Woche",
    sectionNextWeek: "Nächste Woche",
    sectionInvoices: "Letzte Rechnungen",
    fullPlan: "Voller Plan",
    planView: "Plan ansehen",
    allInvoices: "Alle",
  },
  orderList: {
    title: "Alle Aufträge",
    filterStatus: "Status",
    filterSystem: "System",
    filterTeam: "Team",
    empty: "Keine Aufträge gefunden.",
    keinAuftrag: "Kein Auftrag",
  },
  detail: {
    breadcrumb: "Aufträge",
    tabs: {
      overview: "Übersicht",
      photos: "Fotos",
      docs: "Dokumente",
      complaints: "Reklamationen",
    },
    actions: {
      complaint: "Reklamation melden",
      openAB: "AB öffnen",
    },
    cards: {
      installation: "Installation",
      system: "System",
      value: "Vereinbarter Wert",
    },
    fields: {
      address: "Adresse",
      contact: "Kontakt Endkunde",
      term: "Termin",
      crew: "Posádka",
      systemType: "Typ",
      maker: "Hersteller / Modell",
      ab: "Auftragsbestätigung",
      abSigned: (date: string) => `unterzeichnet · ${date}`,
    },
    valueCard: {
      vatNote: "inkl. Material · zzgl. 19 % USt.",
      depositPct: (pct: number) => `Anzahlung (${pct} %)`,
      finalPct: (pct: number) => `Schlussrechnung (${pct} %)`,
    },
  },
  reklamation: {
    eyebrow: "Reklamation melden",
    fields: {
      category: "Kategorie",
      description: "Beschreibung",
      photos: "Fotos · optional",
      urgency: "Dringlichkeit",
    },
    descriptionPlaceholder: "Beschreiben Sie das Problem in mind. 30 Zeichen…",
    photosHint: "Fotos hinzufügen oder hierher ziehen",
    photosLimits: "max. 10 Stück, je 8 MB",
    categories: {
      tech: "Technisches Problem",
      delivery: "Lieferung",
      docs: "Dokumentation",
      other: "Sonstiges",
    },
    urgency: {
      low: "Niedrig",
      mid: "Mittel",
      high: "Hoch",
      critical: "Kritisch",
      criticalNote: "Garantierte Rückmeldung in 4 h während Bürozeiten (Mo–Fr, 8–17 Uhr).",
    },
    cancel: "Abbrechen",
    submit: "Reklamation absenden",
    submitOk: (nr: string) => `Reklamation ${nr} angelegt`,
  },
  balance: {
    title: "Offene Posten",
    subtitle: (date: string) => `Was wir Ihnen schulden, was Sie uns schulden. Stand ${date}.`,
    netto: "Netto-Saldo",
    inFavor: "zu Ihren Gunsten",
    weOwe: "Wir schulden Ihnen",
    theyOwe: "Sie schulden uns",
    posten: (n: number) => `${n} Posten`,
    aging: "Altersstruktur",
    allPaid: "Alles bezahlt.",
    noOpen: "Keine offenen Anzahlungsrechnungen.",
    recentInflows: "Letzte Eingänge",
  },
  map: {
    title: "Karte",
    pinsCount: (n: number) => `${n} Standorte`,
    layers: "Ebenen",
    layerActive: "Aktiv",
    layerPlanned: "Geplant",
    layerDone: "Abgeschlossen",
    layerVehicles: "Fahrzeuge",
    pinSelectAction: "Auftrag öffnen",
    eta: (eta: string) => `ETA ${eta}`,
    speed: (kmh: number) => `Geschwindigkeit ${kmh} km/h`,
    lastUpdate: (sec: number) => `letzte Aktualisierung ${sec} s`,
  },
  shop: {
    eyebrow: "Warmteo · Werkstatt-Kollektion 26",
    title: "Ausrüstung für Ihre Crew. Mit Logo, das hält.",
    subtitle:
      "Workwear und Werkzeug, das auf der Baustelle bestehen will. Bedruckt mit gesticktem Warmteo-Logo, ausgewählt nach Praxistests in DE und CZ.",
    info: {
      shipping: "Versand frei ab 200 €",
      stock: "Lager Leipzig · 2–3 Werktage",
      billing: "Auf Partner-Rechnung",
    },
    comingSoonBadge: "Demnächst verfügbar",
    comingSoonHero: "Shop wird vorbereitet",
    comingSoonNote:
      "Wir bereiten den Werkstatt-Shop gerade vor. Stöbern Sie schon mal — Bestellung folgt in Kürze.",
    notify: "Benachrichtigen, wenn verfügbar",
    filterAll: "Alle",
    filters: {
      caps: "Caps",
      shirts: "Shirts",
      hoodies: "Hoodies",
      jacken: "Jacken",
      muetzen: "Mützen",
      werkzeug: "Werkzeug",
      brillen: "Brillen",
      notes: "Notizbücher",
      stifte: "Stifte",
    },
    soldOut: "Bald lieferbar",
    sortLabel: "Sortierung",
    sizeLabel: "Größe",
  },
  account: {
    usersTitle: "Benutzer",
    usersIntro: "Wer Zugriff auf dieses Portal hat. Administratoren verwalten die Benutzer.",
    inviteTitle: "Benutzer einladen",
    inviteEmailPlaceholder: "kollege@firma.de",
    inviteRole: "Rolle",
    roleAdmin: "Administrator",
    roleMember: "Benutzer",
    invite: "Einladen",
    inviteOkMailed: (email: string) => `Einladung an ${email} gesendet.`,
    inviteOkNoMail:
      "Benutzer angelegt, die E-Mail konnte aber nicht gesendet werden — bitte später erneut einladen.",
    revoke: "Entfernen",
    revokeConfirm: (email: string) => `Zugriff für ${email} wirklich entfernen?`,
    statusActive: "aktiv",
    statusRevoked: "entfernt",
    you: "Sie",
    invitedAt: "Eingeladen",
    lastLogin: "Letzte Anmeldung",
    never: "—",
    signOut: "Abmelden",
  },
  impersonation: {
    banner: (company: string) => `Admin-Vorschau: ${company}`,
    bannerNote: "Nur-Lese-Ansicht für m-CRM Administratoren.",
    stop: "Vorschau beenden",
  },
  notFound: "Seite nicht gefunden",
  loading: "Wird geladen…",
  noAccess:
    "Für dieses Konto ist derzeit kein Partner-Zugang aktiv. Bitte wenden Sie sich an Ihren Ansprechpartner bei Warmteo.",
} as const;
